import { render, staticRenderFns } from "./CantidadesInventario.vue?vue&type=template&id=672d83f1"
import script from "./CantidadesInventario.vue?vue&type=script&lang=js"
export * from "./CantidadesInventario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports